import React from "react";
import Header from './Header';
import Footer from './Footer';
import Jumbotron from './Jumbotron';
import Dic from './Dictionary';
import About from './About';
import Contact from './Contact';
import Game from  './Game';
import Home from './Home';
import Image from './Image'
import Translate from "./Translate";
import QuoteGenerator from "./Quote.jsx";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ImageG from "./ImageGenerate";
class Main extends React.Component{

render(){
    return(
        <Router>
            <div>
                <Header />  
                <Jumbotron/>
                <Switch>
                    <Route exact path="/" >
                          <Home/>
                    </Route>
                    <Route path="/dict" >
                          <Dic/>
                    </Route>
                    <Route path="/about" >
                          <About/>
                    </Route>
                    <Route path="/contact" >
                          <Contact/>
                    </Route>
                    <Route path="/translate" >
                          <Translate/>
                    </Route>
                    <Route path="/transcribe" >
                          <QuoteGenerator/>
                    </Route>
                    <Route path="/imagegenerate" >
                          <Image/>
                    </Route>
                    <Route path="/game" >
                          <Game/>
                    </Route>
                </Switch>
                <Footer/>
            </div>
        </Router>
    )
}

}


export default Main;